//import { Multipane, MultipaneResizer } from "vue-multipane";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import { map } from "../../../functions/HelperFuncs";

export default {
  components: {
    Splitpanes,
    Pane,
  },
  data() {
    return {
      sidebarPx: JSON.parse(
        localStorage.getItem(this.$store.state.company + "_sidebar")
      ),

      minSidebarPX: 250,
      maxSidebarPX: 500,
      minSidebar: 0,
      maxSidebar: 0,
      sidebar: 0,
    };
  },
  mounted() {
    //on window resize
    window.addEventListener("resize", this.calculatePercents);
  },
  created() {
    this.updateSize();
    this.calculatePercents();
  },
  methods: {
    resize(payload) {
      localStorage.setItem(
        this.company + "_sidebar",
        JSON.stringify(payload.width)
      );
    },
    calculatePercents() {
      const width = window.innerWidth;

      if (this.sidebarPx > this.maxSidebarPX) {
        this.sidebarPx = this.maxSidebarPX;
      }

      if (this.sidebarPx < this.minSidebarPX) {
        this.sidebarPx = this.minSidebarPX;
      }

      this.minSidebar = map(this.minSidebarPX, 0, width, 0, 100);
      this.maxSidebar = map(this.maxSidebarPX, 0, width, 0, 100);
      this.sidebar = map(this.sidebarPx, 0, width, 0, 100);
    },
    updateSize(e) {
      if (e) {
        const width = window.innerWidth;
        const size = e[0].size;

        localStorage.setItem(
          `${this.$store.state.company}_sidebar`,
          JSON.stringify(map(size, 0, 100, 0, width))
        );
      }
    },
  },
  unmounted() {
    window.removeEventListener("resize", this.calculatePercents);
  },
};
